import React, { useEffect, useState } from "react";
import reportAPI from "../../api/reportAPI";
import { LoadingSpinner, ErrorMessage } from "../../components/common/ErrorComponents";

const SearchVolumeWidget = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
  const response = await reportAPI.getSearchVolume("daily", 30); // last 30 days
        setData(response);
      } catch (err) {
        setError("Failed to load search volume data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return <LoadingSpinner message="Loading search volume..." />;
  if (error) return <ErrorMessage message={error} />;

  return (
    <div className="dashboard-widget">
      <p><strong>Search Volume (Daily)</strong></p>
      <ul className="list-unstyled">
        {data.map((item, idx) => (
          <li key={idx}>
            {item._id.year}-{item._id.month}-{item._id.day}: {item.total_searches}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SearchVolumeWidget;
